import { useState, useEffect } from 'react'
import { parseISO, format, addMinutes } from 'date-fns'
import { Fetch } from 'customer/function/Fetch'
import { BridalFairDetail } from '../../ParticipationNew.types'

import { ApiResponse } from './type'

type Props = {
  bridalFairDetailKey: string
  startAt: string
}

const toYYYYMMDDhhmm = (dateStr: string): string => {
  return format(parseISO(dateStr), 'yyyyMMddHHmm')
}

export const useParticipationNew = ({
  bridalFairDetailKey,
  startAt,
}: Props): {
  bridalFairDetail: BridalFairDetail | undefined
  fairTimeOptions: {
    label: string
    value: string
  }[]
} => {
  const [bridalFairDetail, setBridalFairDetail] = useState<BridalFairDetail | undefined>(undefined)
  const [fairTimeOptions, setFairTimeOptions] = useState<{ label: string; value: string }[]>([])
  useEffect(() => {
    ;(async () => {
      const url = `/customer/api/v1/bridal_fair_details/${bridalFairDetailKey}/fair_dates/${startAt}`
      const res = await Fetch(url, 'GET', {})
      const { bridalFairParticularDetail, bridalFairDetail } = (await res.json()) as ApiResponse
      setBridalFairDetail({
        key: bridalFairDetail.key,
        name: bridalFairParticularDetail.name,
        mainImageUrl: bridalFairParticularDetail.imageUrl,
        pricing: bridalFairParticularDetail.pricing,
        mainImageData: bridalFairParticularDetail.imageData,
      })
      setFairTimeOptions(
        bridalFairParticularDetail.isNetReservable
          ? bridalFairParticularDetail.fairTimes
              .filter((fairTime) => fairTime.availability !== 'none') // 埋まっている開催枠は選択肢として表示しない
              .sort((a, b) => (parseISO(a.startAt) < parseISO(b.startAt) ? -1 : 1)) // 昇順でsort
              .map((fairTime) => ({
                label: `${format(parseISO(fairTime.startAt), 'HH:mm')}〜${format(
                  addMinutes(parseISO(fairTime.startAt), bridalFairDetail.bridalFair.minutes),
                  'HH:mm',
                )}`,
                value: toYYYYMMDDhhmm(fairTime.startAt),
              }))
          : [],
      )
    })()
  }, [bridalFairDetailKey, startAt])

  return {
    bridalFairDetail,
    fairTimeOptions,
  }
}
